module.exports = __webpack_public_path__ + "img/quickbooks_icon.1e72fb16.png";